import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import SectionChapter from '../../SectionChapter';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PaletteIcon from '@material-ui/icons/Palette';
import LineWeightIcon from '@material-ui/icons/LineWeight';

const ConnectorIcon = ({ className }) => (
    <svg className={className} style={{ verticalAlign: 'middle', width: 36, height: 36 }} viewBox='0 0 24 24'>
        <line x1='5' y1='19' x2='19' y2='5' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
        <polyline points='12,5 19,5 19,12' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round'
                  strokeLinejoin='round' />
    </svg>
);

const LinePreview = ({ className }) => (
    <svg className={className} style={{ verticalAlign: 'middle', width: 48, height: 24 }} viewBox='0 0 48 24'>
        <line x1='4' y1='12' x2='44' y2='12' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
    </svg>
);

const ArrowOpenPreview = ({ className }) => (
    <svg className={className} style={{ verticalAlign: 'middle', width: 48, height: 24 }} viewBox='0 0 48 24'>
        <line x1='4' y1='12' x2='44' y2='12' stroke='currentColor' strokeWidth='2' />
        <polyline points='34,5 44,12 34,19' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round'
                  strokeLinejoin='round' />
    </svg>
);

const ArrowFilledPreview = ({ className }) => (
    <svg className={className} style={{ verticalAlign: 'middle', width: 48, height: 24 }} viewBox='0 0 48 24'>
        <line x1='4' y1='12' x2='36' y2='12' stroke='currentColor' strokeWidth='2' />
        <polygon points='44,12 34,5 34,19' fill='currentColor' />
    </svg>
);

const DoubleArrowOpenPreview = ({ className }) => (
    <svg className={className} style={{ verticalAlign: 'middle', width: 48, height: 24 }} viewBox='0 0 48 24'>
        <line x1='4' y1='12' x2='44' y2='12' stroke='currentColor' strokeWidth='2' />
        <polyline points='14,5 4,12 14,19' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round'
                  strokeLinejoin='round' />
        <polyline points='34,5 44,12 34,19' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round'
                  strokeLinejoin='round' />
    </svg>
);

const DoubleArrowFilledPreview = ({ className }) => (
    <svg className={className} style={{ verticalAlign: 'middle', width: 48, height: 24 }} viewBox='0 0 48 24'>
        <line x1='12' y1='12' x2='36' y2='12' stroke='currentColor' strokeWidth='2' />
        <polygon points='4,12 14,5 14,19' fill='currentColor' />
        <polygon points='44,12 34,5 34,19' fill='currentColor' />
    </svg>
);

const DashedLinePreview = ({ className }) => (
    <svg className={className} style={{ verticalAlign: 'middle', width: 48, height: 24 }} viewBox='0 0 48 24'>
        <line x1='4' y1='12' x2='44' y2='12' stroke='currentColor' strokeWidth='2' strokeDasharray='6 4' />
    </svg>
);

const DottedLinePreview = ({ className }) => (
    <svg className={className} style={{ verticalAlign: 'middle', width: 48, height: 24 }} viewBox='0 0 48 24'>
        <line x1='4' y1='12' x2='44' y2='12' stroke='currentColor' strokeWidth='2' strokeDasharray='2 4' />
    </svg>
);

const ConnectorManagement = ({ language, classes, refs }) => {
    let explanations = [
        {
            id: 'tutorial.connectors.explanation1',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.connectors.toolIcon'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                            <ConnectorIcon className={classes.sampleFab} />
                        </Typography>
                    </li>
                </ul>
            ),
            img: [
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/ConnectorTool.jpg`,
            ],
        },
        {
            id: 'tutorial.connectors.types',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.connectors.type.line'
                                values={{ b: (chunks) => <b>{chunks}</b> }}
                            />
                            <LinePreview className={classes.sampleFab} />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.connectors.type.arrowOpen'
                                values={{ b: (chunks) => <b>{chunks}</b> }}
                            />
                            <ArrowOpenPreview className={classes.sampleFab} />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.connectors.type.arrowFilled'
                                values={{ b: (chunks) => <b>{chunks}</b> }}
                            />
                            <ArrowFilledPreview className={classes.sampleFab} />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.connectors.type.doubleArrowOpen'
                                values={{ b: (chunks) => <b>{chunks}</b> }}
                            />
                            <DoubleArrowOpenPreview className={classes.sampleFab} />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.connectors.type.doubleArrowFilled'
                                values={{ b: (chunks) => <b>{chunks}</b> }}
                            />
                            <DoubleArrowFilledPreview className={classes.sampleFab} />
                        </Typography>
                    </li>
                </ul>
            ),
            img: [
                `/static/asset/img/tutorial/noText/ConnectorTypes.jpg`,
            ],
        },
        {
            id: 'tutorial.connectors.drawing',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.connectors.drawing.explanation'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                    li: (chunks) => (
                                        <span>
                                            {chunks}
                                            <br></br>
                                            <br></br>
                                        </span>
                                    ),
                                }}
                            />
                        </Typography>
                    </li>
                </ul>
            ),
            img: [],
        },
        {
            id: 'tutorial.connectors.editing',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.connectors.editing.explanation'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                    li: (chunks) => (
                                        <span>
                                            {chunks}
                                            <br></br>
                                            <br></br>
                                        </span>
                                    ),
                                }}
                            />
                            <MoreVertIcon className={classes.sampleFab} />
                        </Typography>
                    </li>
                </ul>
            ),
            img: [
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/ConnectorEdit.jpg`,
                `/static/asset/img/tutorial/noText/ConnectorMove.jpg`,
            ],
        },
        {
            id: 'tutorial.connectors.styling',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.connectors.styling.color'
                                values={{ b: (chunks) => <b>{chunks}</b> }}
                            />
                            <PaletteIcon className={classes.sampleFab} />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.connectors.styling.weight'
                                values={{ b: (chunks) => <b>{chunks}</b> }}
                            />
                            <LineWeightIcon className={classes.sampleFab} />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.connectors.styling.lineStyle'
                                values={{ b: (chunks) => <b>{chunks}</b> }}
                            />
                            <DashedLinePreview className={classes.sampleFab} />
                            <DottedLinePreview className={classes.sampleFab} />
                        </Typography>
                    </li>
                </ul>
            ),
            img: [
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/ConnectorStyle.jpg`,
            ],
        },
    ];
    return (
        <SectionChapter
            refs={refs}
            id={'section-manageLesson-connectors'}
            title={'tutorial.manageLesson.connectors.title'}
            explanations={explanations}
            imageTop={false}
        />
    );
};

export default ConnectorManagement;
